import authService from 'modules/auth/services';
import settingGeneralConfigurationService from 'modules/settings/general_configuration/services';
import { refreshToken } from 'modules/auth/services/saga';
import cashierService from 'modules/POS/services';
import productService from 'modules/settings/product/services';
import staffService from 'modules/settings/staff/services';
import ticketService from 'modules/tickets/services';
import { all, fork } from 'redux-saga/effects';
import shopService from 'modules/shop/services';
import reportService from 'modules/report/services';
import customerService from 'modules/customer/services';
import giftCardService from 'modules/gift-card/services';
import creditCardService from 'modules/credit_card/services';
import homeService from 'modules/dashboard/services';
import supplierService from 'modules/settings/supplier/services';

export default function* rootSaga() {
  yield all([
    fork(authService.sagas),
    fork(staffService.sagas),
    fork(productService.sagas),
    fork(ticketService.sagas),
    fork(cashierService.sagas),
    fork(settingGeneralConfigurationService.sagas),
    fork(shopService.sagas),
    fork(reportService.sagas),
    fork(customerService.sagas),
    fork(giftCardService.sagas),
    fork(creditCardService.sagas),
    fork(homeService.sagas),
    fork(supplierService.sagas),
  ]);
  yield refreshToken();
}
